import { createTheme } from '@mui/material/styles';
import { ptBR } from '@mui/material/locale';

import COLORS from '../utils/colors';

export default createTheme(
  {
    breakpoints: {
      values: {
        mobile: 0,
        tablet: 640,
        laptop: 1024,
        desktop: 1280,
        largedesktop: 1680,
      },
    },

    typography: {
      fontFamily: ['Roboto', ' sans-serif'].join(','),
    },

    palette: {
      primary: {
        main: COLORS.conlicitaBlue,
        light: COLORS.conlicitaLightBlue,
      },
      secondary: {
        main: COLORS.conlicitaGreen,
        light: COLORS.conlicitaLightGreen,
      },
      error: {
        main: COLORS.redWarning,
      },
      background: {
        default: COLORS.background,
      },
    },
  },

  ptBR,
);
